export default __webpack_public_path__ + "static/media/inviteSignup3.046ab01f.svg";